import script from "./ShippingDetailsQuantityV2.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShippingDetailsQuantityV2.vue?vue&type=script&setup=true&lang=ts"

import "./ShippingDetailsQuantityV2.vue?vue&type=style&index=0&id=d2a57abe&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d2a57abe"]])

export default __exports__